export default [
  {
    path: '/activity-20260101-main',
    component: () => import('./Page.vue'),
    meta: { expire: '2026-01-10T23:59:59.000+08:00', title: '元旦', id: 15 },
  },
  {
    path: '/activity-20260101-rule',
    component: () => import('./Rule.vue'),
    meta: { expire: '2026-01-10T23:59:59.000+08:00', title: '元旦-规则', id: 15 },
  },
]
